<div class="row locations-row no-gutters" *ngFor="let location of data">
  <div class="col-md-2">
    <img src="{{bucketUrl}}/images/{{ location.country }}.png" >
  </div>
  <div class="col-md-9 mt-10">
    <a [routerLink]="['/locations',location.city | removeSpace]">{{location.city}}</a>
  </div>
</div>
